import React from "react";
import styled from "styled-components";
import LegacyIcon from "components/icons/legacy-icon";
import { useRouter } from "next/router";

const NoSearchWrapper = styled.div`
  margin: auto;
  max-width: 275px;
  text-align: center;
  justify-content: center;
  align-self: center;
`;

const HeaderTitle = styled.h3`
  font-size: 24px;
`;

const SubText = styled.p`
  font-size: 16px;
  font-weight: 400;
`;

const IconWrapper = styled.div`
  padding: 3rem 0 2rem 0;

  ${({ theme }) => theme.mq.sm`
    padding: 6rem 0 2rem 0;
  `}
`;

const HelpText = styled.p`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: 0.875rem;

  a {
    color: ${({ theme }) => theme.themeColors.orange1};
    font-weight: 400;
  }
`;

const NoSearchResults = () => {
  const { query } = useRouter();
  return (
    <NoSearchWrapper>
      <IconWrapper>
        <LegacyIcon name="no-results-63" color="orange" />
      </IconWrapper>
      <HeaderTitle>No search results </HeaderTitle>
      {query.q ? (
        <>
          <SubText>
            Sorry, we couldn’t find a match for “{query.q}” in{" "}
            {query.formattedAddress}
          </SubText>
          <HelpText>
            Check the spelling of the business name that you’re looking for
          </HelpText>
          <HelpText>
            Need help? <br />{" "}
            <a href="mailto:support@goodfriend.com">Contact Customer Service</a>
          </HelpText>
        </>
      ) : (
        <SubText>
          Sorry, we couldn’t find any businesses who accepts online booking in “
          {query.formattedAddress}”
        </SubText>
      )}
    </NoSearchWrapper>
  );
};

export default NoSearchResults;
